import { ec_zhCN as ec } from './module/ec';
import { marketing_zhCN as marketing } from './module/marketing';
import { adjustment_zhCN as adjustment } from './module/adjustment';
import { report_zhCN as report } from './module/report';
import { wechat_zhCN as wechat } from './module/wechat';
import { goods_zhCN as goods } from './module/goods';
import { cm_zhCN as cm } from './module/cm';
import { blackList_zhCN as blackList } from './module/blackList';
import { coupon_zhCN as coupon } from './module/coupon';
import { coupon_zhCN as coupon2 } from './module/coupon2';
import { message_zhCN as message } from './module/message';
import { order_zhCN as order } from './module/order';

export default {
  'comm.date.lbl.01': `天`,
  'comm.date.lbl.02': `天`,
  'comm.date.lbl.03': `日`,
  'comm.date.lbl.04': `周`,
  'comm.date.lbl.05': `月`,
  'comm.amount.lbl.01': `元`,
  'comm.time.lbl.01': `秒`,
  'comm.time.lbl.02': `时`,
  'comm.pagination.lbl.01': `总计`,
  'comm.pagination.lbl.02': `商品`,
  'comm.pagination.lbl.03': `上一页`,
  'comm.pagination.lbl.04': `下一页`,
  'comm.pagination.lbl.05': `页`,
  'comm.pagination.lbl.06': `条`,
  'comm.action.btn.01': `查询`,
  'comm.action.btn.02': `新增`,
  'comm.action.btn.03': `编辑`,
  'comm.action.btn.04': `删除`,
  'comm.action.btn.05': `详情`,
  'comm.action.btn.06': `重置`,
  'comm.action.btn.07': `确认`,
  'comm.action.btn.08': `取消`,
  'comm.action.btn.09': `数据`,
  'comm.action.btn.10': `暂停`,
  'comm.action.btn.11': `终止`,
  'comm.action.btn.12': `审核`,
  'comm.action.btn.13': `下一步`,
  'comm.action.btn.14': `上一步`,
  'comm.action.btn.15': `立即新建`,
  'comm.action.btn.16': `退出`,
  'comm.action.btn.17': `完成`,
  'comm.action.btn.18': `重启`,
  'comm.action.btn.19': `立即发送`,
  'comm.action.btn.20': `导入`,
  'comm.action.btn.21': `下载`,
  'comm.action.btn.22': `添加`,
  'comm.month.lbl.1': `1月`,
  'comm.month.lbl.2': `2月`,
  'comm.month.lbl.3': `3月`,
  'comm.month.lbl.4': `4月`,
  'comm.month.lbl.5': `5月`,
  'comm.month.lbl.6': `6月`,
  'comm.month.lbl.7': `7月`,
  'comm.month.lbl.8': `8月`,
  'comm.month.lbl.9': `9月`,
  'comm.month.lbl.10': `10月`,
  'comm.month.lbl.11': `11月`,
  'comm.month.lbl.12': `12月`,
  'comm.msg.txt.01': `暂无数据`,
  'comm.msg.txt.02': `服务器开小差了…`,
  'comm.chart.lbl.01': `总`,
  'comm.chart.lbl.02': `平均`,
  'comm.chart.lbl.03': `瓶`,
  'comm.chart.lbl.04': `人`,
  'comm.chart.lbl.05': `次`,
  'comm.chart.lbl.06': `页`,
  'comm.chart.lbl.07': `折`,
  'comm.chart.lbl.08': `倍`,
  'comm.chart.lbl.09': `分`,
  'comm.chart.lbl.10': `张`,
  'comm.dcz.txt.01': `数据统计截止：{data}  23:59`,

  'ec.menu': `会员指数盘`,
  'ec.dashboard.menu': `概览`,
  'cm.menu': `线下门店/官网/小程序`,
  'cm.member.menu': `会员管理`,
  'cm.member.detail.menu': `会员详情`,
  'cm.search.menu': `会员查询`,
  'cm.analysis.menu': `会员分析`,
  'cm.black.menu': `黑名单`,
  'order.menu': `订单管理`,
  'online.menu': `天猫/京东/抖音/唯品会`,
  'order.order.menu': `订单管理`,
  'order.order.detail.menu': `订单详情`,
  'rule.menu': `规则引擎`,
  'rule.field.menu': `字段管理`,
  'rule.field.cfpm.menu': `系统字段`,
  'rule.field.tvf.menu': `临时变量`,
  'rule.rules.menu': `规则管理`,
  'rule.models.menu': `模型管理`,
  'rule.decision.menu': `决策图管理`,
  'rule.decision.mgt.menu': `决策图管理`,
  'rule.decision.version.menu': `决策图版本管理`,
  'rule.decision.validation.menu': `决策图复核`,
  'rule.decision.test.menu': `决策图测试`,
  'rule.decision.tests.menu': `决策图批量测试`,
  'login.menu': `登录`,
  'ec.report.menu': `电商指标`,
  'voucher.menu': `优惠券中心`,
  'voucher.mgt.menu': `优惠券管理`,
  'voucher.mgt.volume.menu': `满减券`,
  'voucher.mgt.pricevalue.menu': `折扣券`,
  'voucher.mgt.exchange.menu': `兑换券`,
  'voucher.mgt.pricequantity.menu': `满折券`,
  'voucher.writeoff.menu': `优惠券核销`,
  'voucher.data.menu': `优惠券数据`,

  'item.menu': `商品管理`,
  'item.gift.menu': `礼品管理`,
  'item.gift.add.menu': `添加礼品`,
  'item.gift.edit.menu': `编辑礼品`,
  'item.gift.view.menu': `查看礼品`,
  'wechat.menu': `微信管理`,
  'wechat.authorize.menu': `账号授权`,
  'wechat.official.menu': `公众号模板消息`,
  'wechat.official.add.menu': `添加模板`,
  'wechat.official.edit.menu': `编辑模板`,
  'message.menu': `短信管理`,
  'message.templet.menu': `短信模板`,
  'message.templet.add.menu': `添加模板`,
  'adjustment.menu': `人工调整`,
  'adjustment.members.menu': `会员调整`,
  'adjustment.members.edit.menu': `编辑`,
  'adjustment.members.store.menu': `转柜`,
  'adjustment.members.level.menu': `等级调整`,
  'adjustment.members.inetgral.menu': `积分调整`,
  'adjustment.members.merge.menu': `卡号合并`,
  'adjustment.batch.menu': `批量调整`,
  'adjustment.records.menu': `会员调整记录`,
  'report.menu': `票房分析`, // 报表中心
  'report.newpurchased.menu': `新增有购买会员`,
  'report.health.menu': `概览看板`, // Brand Health Check
  'report.perform_sales.menu': `剧目销售报表`,
  'report.bigscreen.menu': `全域大屏`,
  'report.retail.menu': `Retail Excellence Project 2021-2022`,
  'report.retail.detail.menu': `会员详情`,
  'data.tools.menu': `取数工具`,

  'login.n01.lbl01': `账号登录`,
  'login.n01.lbl02': `用户名`,
  'login.n01.placeholder03': `请输入`,
  'login.n01.lbl04': `密码`,
  'login.n01.placeholder05': `密码`,
  'login.n01.btn06': `登录`,
  'login.n01.msg07': `请输入用户名`,
  'login.n01.msg08': `请输入密码`,

  'login.n02.lbl01': `扫码登录更安全`,
  'login.n02.lbl02': `手机扫码，安全登录`,
  'login.n02.lbl03': `打开企业微信，扫码登录`,
  'login.d01.lbl01': `请输入原密码`,
  'login.d01.lbl02': `请输入新密码`,
  'login.d01.lbl03': `请再次输入新密码`,

  ...ec,
  ...marketing,
  ...adjustment,
  ...report,
  ...wechat,
  ...cm,
  ...blackList,
  ...coupon,
  ...coupon2,
  ...message,
  ...order,
  ...goods,
  'cm.search.n01.lbl01': `舒履会`,
  'cm.search.n01.lbl02': `会员查询`,
  'cm.search.n01.placeholder03': `会员号/手机号`,
  'cm.search.n01.btn04': `重置`,
  'cm.search.n01.btn05': `搜索`,
  'cm.analysis.n01.chb01': `门店`,
  'cm.analysis.n01.rdo02': `开始日期`,
  'cm.analysis.n01.txt03': `至`,
  'cm.analysis.n01.rdo04': `结束日期`,
  'cm.analysis.n01.btn05': `重置`,
  'cm.analysis.n01.btn06': `查询`,
  'cm.analysis.d01.rdo01': `选择日期范围`,
  'cm.analysis.d01.btn02': `切换详情`,
  'cm.analysis.n02.lbl01': `新增注册会员`,
  'cm.analysis.n02.lbl02': `新增有购买会员`,
  'cm.analysis.n02.lbl03': `销售笔数`,
  'cm.analysis.n02.lbl04': `销售票数`,
  'cm.analysis.n02.lbl05': `销售金额`,
  'cm.analysis.n02.lbl06': `新会员销售笔数`,
  'cm.analysis.n02.lbl07': `老会员销售笔数`,
  'cm.analysis.n02.lbl08': `非会员销售笔数`,
  'cm.analysis.c01.lbl01': `区域`,
  'cm.analysis.c01.lbl02': `门店编号`,
  'cm.analysis.c01.lbl03': `门店名称`,
  'cm.analysis.c01.lbl04': `门店类型`,
  'cm.analysis.c01.lbl05': `新会员量`,
  'cm.analysis.c01.lbl06': `销售笔数`,
  'cm.analysis.c01.lbl07': `新增有购买会员`,
  'cm.analysis.c01.lbl08': `销售票数`,
  'cm.analysis.c01.lbl09': `销售金额`,
  'cm.analysis.c01.lbl10': `新会员占比`,
  'cm.analysis.c01.lbl11': `老会员占比`,
  'cm.analysis.c01.lbl12': `非会员占比`,
  // 'cm.analysis.c01.tip13': `新会员量`,
  'cm.analysis.c01.tip13': `新增会员注册数量`,
  // 'cm.analysis.c01.tip14': `新会员占比`,
  'cm.analysis.c01.tip14': `指定时间内注册的会员产生的订单笔数在销售笔数中的占比`,
  // 'cm.analysis.c01.tip15': `老会员占比`,
  'cm.analysis.c01.tip15': `非指定时间内注册的会员产生的订单笔数在销售笔数中的占比`,
  // 'cm.analysis.c01.tip16': `非会员占比`,
  'cm.analysis.c01.tip16': `未注册的会员产生的订单笔数在销售笔数中的占比`,
  'cm.analysis.c01.tip17': `销售仅统计鞋和配件，且不包含礼券零售、员工工鞋和试用装的订单`,

  'item.gift.n01.lbl01': `礼品编号`,
  'item.gift.n01.lbl02': `礼品标题`,
  'item.gift.n01.rdo03': `礼品状态`,
  'item.gift.n01.rdo04': `礼品分组`,
  'item.gift.n01.rdo05': `礼品类别`,
  'item.gift.n01.rdo06': `礼品类目`,
  'item.gift.n02.btn01': `添加礼品`,
  'item.gift.n02.btn02': `导出列表`,
  'item.gift.c01.lbl01': `礼品编号`,
  'item.gift.c01.lbl02': `礼品标题`,
  'item.gift.c01.lbl03': `礼品分组`,
  'item.gift.c01.lbl04': `礼品类别`,
  'item.gift.c01.lbl05': `礼品类目`,
  'item.gift.c01.lbl06': `兑换积分`,
  'item.gift.c01.lbl07': `已领数量`,
  'item.gift.c01.lbl08': `剩余数量`,
  'item.gift.c01.lbl09': `创建时间`,
  'item.gift.c01.lbl10': `礼品状态`,
  'item.gift.c01.lbl11': `操作`,
};
